import { render, staticRenderFns } from "./IrAOVRechazada.vue?vue&type=template&id=4c1899f3&lang=pug"
import script from "./IrAOVRechazada.vue?vue&type=script&lang=js"
export * from "./IrAOVRechazada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports